import TextInput from '../TextInput';
import DateInput from '../DateInput';
import BooleanSelect from '../BooleanSelect';

function getValue(func, ...args) {
  return ({target: {value=''}={}}={}) => {
    func(...args, value);
  };
}

export default function StepFive({
  has_behavior_profile, behavior_profile={}, behavior_profile_options, updateField, errors={}
}) {
  const updateBP = (name, value) => {
    updateField(['behavior_profile', name], value);
  }

  const {evaluator_name, evaluation_date} = behavior_profile;
  const behaviorFieldSet = _.pick(behavior_profile, _.keys(behavior_profile_options));
  const has_errors = errors['behavior_profile_evaluator_name'] || errors['behavior_profile_evaluation_date'];

  return (
    <div>
      <BooleanSelect
        complete={has_behavior_profile}
        label="Has your horse completed the Basic Behavior Profile?"
        required={true}
        fieldName="has_behavior_profile"
        updateField={updateField}
        trueLabel="Yes"
        falseLabel="No"/>
      {has_behavior_profile && <>
        <div className="row">
          <div className="col-lg-7 border-0">
            <TextInput
              fieldName="name"
              label="Evaluator Name"
              required={true}
              placeholder="Evaluator Name"
              value={evaluator_name}
              updateField={getValue(updateBP, 'evaluator_name')}
              error={errors['behavior_profile_evaluator_name']}
              has_errors={has_errors}/>
          </div>
          <div className="col-lg-5">
            <DateInput
              fieldName="name"
              label="Date Evaluated"
              required={true}
              value={evaluation_date}
              has_errors={has_errors}
              error={errors['behavior_profile_evaluation_date']}
              updateField={getValue(updateBP, 'evaluation_date')}/>
          </div>
        </div>
        {_.map(behaviorFieldSet, (complete, fieldName) => (
          <BooleanSelect key={fieldName}
            complete={complete}
            label={behavior_profile_options[fieldName]}
            fieldName={fieldName}
            updateField={updateBP}/>
        ))}
      </>}
    </div>
  );
}
